import { Form, Input, Button, Checkbox } from 'antd'
import { LoginBody } from 'api/auth/login'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ValidateErrorEntity } from 'rc-field-form/lib/interface'
import { loginAction } from 'slices/auth'
import handleFormError from 'utils/handleFormError'

const LoginForm = () => {
	const { loading } = useAppSelector(state => state.auth)
	const dispatch = useAppDispatch()

	const onFinish = async (values: LoginBody) => {
		dispatch(loginAction(values))
	}

	const onFinishFailed = (errorInfo: ValidateErrorEntity) => {
		handleFormError(errorInfo)
	}

	return (
		<Form
			name='login'
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			layout='vertical'
			initialValues={{
				email: '',
				password: '',
				rememberMe: false,
				source: 'WEB_APP',
			}}
			autoComplete='off'
		>
			<Form.Item
				label='Email'
				name='email'
				rules={[
					{
						required: true,
						message: 'Email is required',
					},
					{
						pattern:
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						message: 'Please enter a valid Email',
					},
				]}
			>
				<Input />
			</Form.Item>

			<Form.Item
				label='Password'
				name='password'
				rules={[{ required: true, message: 'Password is Required' }]}
			>
				<Input.Password />
			</Form.Item>

			<Form.Item name='rememberMe' valuePropName='checked'>
				<Checkbox>Remember me</Checkbox>
			</Form.Item>

			<Form.Item name='source' hidden>
				<Input />
			</Form.Item>

			<Form.Item>
				<Button type='primary' htmlType='submit' block loading={loading}>
					Login
				</Button>
			</Form.Item>
		</Form>
	)
}

export default LoginForm
